<template>
  <div id="weathermap" class="weathermap-container">
    <div
      class="grid"
      v-for="(map, id) in maps"
      :key="id"
      :style="'width:' + 100 / maps.length + '%'"
    >
      <keep-alive>
        <Map :id="id"></Map>
      </keep-alive>
    </div>
  </div>
</template>
 
<script>
import Map from "./MapV2";
import moment from "moment";
import _ from "lodash";
export default {
  components: {
    Map,
  },
  data: () => {
    let date = moment().format("YYYY-MM-DD");
    return {
      env: window._env,
      isChrome: true,
      user: window.user || {},
      maps: ["v-map"],
      map: {
        minZoom: 4,
        maxZoom: 12,
        center: [46, 2],
        zoom: 6,
      },
      mapState: {
        mouseX: 0,
        mouseY: 0,
        mouseLng: 0,
        mouseLat: 0,
        center: {},
        zoom: null,
        datetime: date,
        model: "",
        run: 0,
        t: 1,
        sync: true,
      },
      models: [
        {
          name: "Selectionnez un modèle",
          param: "",
          runs: [],
        },
        {
          name: "Arome 2.5km",
          param: "arome0p025",
          runs: [],
        },
        {
          name: "Arpège 10km",
          param: "arpege0p1",
          runs: [],
        },
        {
          name: "GFS 25km",
          param: "gfs0p25",
          runs: [],
        },
        {
          name: "WRF-ARW 10km",
          param: "arwfr10",
          runs: [],
        },
      ],
      tooltip: {
        show: false,
        x: 0,
        y: 0,
        value: null,
        unit: null,
      },
      units: {
        temp: { name: "temp", unit: "°C" },
        tempsfc: { name: "tempsfc", unit: "°C" },
        windf: { name: "windf", unit: "km/h", coef: 3.6 },
        gust: { name: "gust", unit: "km/h", coef: 3.6 },
        windd: { name: "windd", unit: "deg" },
        unit: { name: "unit", unit: "%" },
        // unit: { name: "unit", unit: "%" },
        // unit: { name: "unit", unit: "%" },
        precip: { name: "precip", unit: "mm" },
        refc: { name: "reflectivité", unit: "dBZ" },
        snow: { name: "snow", unit: "cm" },
        graupel: { name: "graupel", unit: "mm" },
        cape: { name: "cape", unit: "j/kg" },
        cin: { name: "cin", unit: "" },
        lcl: { name: "lcl", unit: "%" },
        mcl: { name: "mcl", unit: "%" },
        hcl: { name: "hcl", unit: "%" },
        lftx: { name: "lftx", unit: "" },
        iso0: { name: "iso 0°C", unit: "m" },
        iso268K: { name: "iso -5°C", unit: "m" },
        iso263K: { name: "iso -10°C", unit: "m" },
      },
      params: {
        temp_surface: {
          name: "Temp. <small>surface</small>",
          type: "raster",
          zIndex: 100,
          isError: false,
          isReady: false,
          isLoaded: false,
          isSelected: false,
          paramUrl: ["tempsfc"],
          colors: [
            "blue",
            "turquoise",
            "limegreen",
            "gold",
            "indianred",
            "darkred",
          ],
          colorsDomain: [0, 40, 100, 160, 230, 255],
          rangeBars: null,
          range: null,
          rangeSeg: 11,
          globalAlpha: 0.6,
          imageSmoothingEnabled: false,
        },
        temp_air: {
          name: "Temp. <small>air</small>",
          type: "raster",
          zIndex: 100,
          isError: false,
          isReady: false,
          isLoaded: false,
          isSelected: false,
          paramUrl: ["temp"],
          colors: [
            "blue",
            "turquoise",
            "limegreen",
            "gold",
            "indianred",
            "darkred",
          ],
          colorsDomain: [0, 40, 100, 160, 230, 255],
          rangeBars: null,
          range: null,
          rangeSeg: 11,
          globalAlpha: 0.6,
          imageSmoothingEnabled: false,
        },
        wind: {
          name: "Vent",
          type: "raster",
          zIndex: 100,
          isError: false,
          isReady: false,
          isLoaded: false,
          isSelected: false,
          paramUrl: ["windf"],
          colors: [
            "blue",
            "turquoise",
            "limegreen",
            "gold",
            "indianred",
            "darkred",
          ],
          colorsDomain: [0, 40, 100, 160, 230, 255],
          rangeBars: null,
          range: null,
          // rangeSeg: 11,
          globalAlpha: 0.6,
          imageSmoothingEnabled: false,
        },
        wind_arrow: {
          name: "Vent <small>direction</small>",
          type: "arrow",
          zIndex: 100,
          isError: false,
          isReady: false,
          isLoaded: false,
          isSelected: false,
          paramUrl: ["windd", "windf"],
          colors: [
            "blue",
            "turquoise",
            "limegreen",
            "gold",
            "indianred",
            "darkred",
          ],
          colorsDomain: [0, 40, 100, 160, 230, 255],
          rangeBars: null,
          range: null,
          // rangeSeg: 11,
          globalAlpha: 1,
          imageSmoothingEnabled: false,
        },
        wind_gust: {
          name: "Vent <small>rafale</small>",
          type: "raster",
          zIndex: 102,
          isError: false,
          isReady: false,
          isLoaded: false,
          isSelected: false,
          paramUrl: ["gust"],
          colors: [
            "blue",
            "turquoise",
            "limegreen",
            "gold",
            "indianred",
            "darkred",
          ],
          colorsDomain: [0, 40, 100, 160, 230, 255],
          rangeBars: null,
          range: null,
          // rangeSeg: 11,
          globalAlpha: 0.6,
          imageSmoothingEnabled: false,
        },
        wind_velocity: {
          name: "Vent <small>animation</small>",
          type: "particule",
          zIndex: 150,
          isError: false,
          isReady: false,
          isLoaded: false,
          isSelected: false,
          paramUrl: ["windf", "windd"],
          fade: 0.95,
          width: 1,
          cardinal: 1800,
          velocity: 1000,
          maxAge: 100,
          color: "rgba(255,255,255,0.8)",
          rangeBars: null,
          range: null,
          globalAlpha: 1,
        },
        cloud_coverage_low: {
          name: "Basse <small>(0 à 3k)</small>",
          type: "raster",
          zIndex: 106,
          isError: false,
          isReady: false,
          isLoaded: false,
          isSelected: false,
          paramUrl: ["lcl"],
          colors: ["#444444", "#444444"],
          noZero: true,
          dynAlpha: true,
          rangeBars: null,
          range: null,
          globalAlpha: 1,
          imageSmoothingEnabled: true,
        },
        cloud_coverage_med: {
          name: "Moyenne <small>(3k à 6k)</small>",
          type: "raster",
          zIndex: 102,
          isError: false,
          isReady: false,
          isLoaded: false,
          isSelected: false,
          paramUrl: ["mcl"],
          colors: ["#AAAAAA", "#AAAAAA"],
          noZero: true,
          dynAlpha: true,
          rangeBars: null,
          range: null,
          globalAlpha: 1,
          imageSmoothingEnabled: true,
        },
        cloud_coverage_high: {
          name: "Haute <small>(+ 6k)</small>",
          type: "raster",
          zIndex: 100,
          isError: false,
          isReady: false,
          isLoaded: false,
          isSelected: false,
          paramUrl: ["hcl"],
          colors: ["#EEEEEE", "#EEEEEE"],
          noZero: true,
          dynAlpha: true,
          rangeBars: null,
          range: null,
          globalAlpha: 1,
          imageSmoothingEnabled: true,
        },
        rain: {
          name: "Précipitation <small>totale</small>",
          type: "raster",
          zIndex: 102,
          isError: false,
          isReady: false,
          isLoaded: false,
          isSelected: false,
          paramUrl: ["precip"],
          colors: [
            "blue",
            "turquoise",
            "limegreen",
            "gold",
            "indianred",
            "darkred",
          ],
          colorsDomain: [0, 40, 100, 160, 230, 255],
          noZero: true,
          // dynAlpha: true,
          rangeBars: null,
          range: null,
          globalAlpha: 0.6,
          imageSmoothingEnabled: false,
        },
        snow: {
          name: "Précipitation <small>neige</small>",
          type: "raster",
          zIndex: 120,
          isError: false,
          isReady: false,
          isLoaded: false,
          isSelected: false,
          paramUrl: ["snow"],
          colors: [
            "blue",
            "turquoise",
            "limegreen",
            "gold",
            "indianred",
            "darkred",
          ],
          colorsDomain: [0, 40, 100, 160, 230, 255],
          noZero: true,
          // dynAlpha: true,
          rangeBars: null,
          range: null,
          globalAlpha: 0.6,
          imageSmoothingEnabled: false,
        },
        graupel: {
          name: "Précipitation <small>graupel</small>",
          type: "raster",
          zIndex: 120,
          isError: false,
          isReady: false,
          isLoaded: false,
          isSelected: false,
          paramUrl: ["graupel"],
          colors: [
            "blue",
            "turquoise",
            "limegreen",
            "gold",
            "indianred",
            "darkred",
          ],
          colorsDomain: [0, 40, 100, 160, 230, 255],
          noZero: true,
          // dynAlpha: true,
          rangeBars: null,
          range: null,
          globalAlpha: 0.6,
          imageSmoothingEnabled: false,
        },
        refc: {
          name: "Réflectivité",
          type: "raster",
          zIndex: 120,
          isError: false,
          isReady: false,
          isLoaded: false,
          isSelected: false,
          paramUrl: ["refc"],
          colors: [
            "blue",
            "turquoise",
            "limegreen",
            "gold",
            "indianred",
            "darkred",
          ],
          colorsDomain: [0, 40, 100, 160, 230, 255],
          noZero: true,
          // dynAlpha: true,
          rangeBars: null,
          range: null,
          globalAlpha: 0.6,
          imageSmoothingEnabled: false,
        },
        cape: {
          name: "CAPE",
          type: "raster",
          zIndex: 110,
          isError: false,
          isReady: false,
          isLoaded: false,
          isSelected: false,
          paramUrl: ["cape"],
          colors: [
            "white",
            "turquoise",
            "limegreen",
            "gold",
            "indianred",
            "darkred",
          ],
          colorsDomain: [0, 50, 120, 150, 190, 255],
          rangeBars: null,
          range: null,
          globalAlpha: 0.6,
          imageSmoothingEnabled: false,
        },
        cin: {
          name: "CIN",
          type: "raster",
          zIndex: 110,
          isError: false,
          isReady: false,
          isLoaded: false,
          isSelected: false,
          paramUrl: ["cin"],
          colors: [
            "blue",
            "turquoise",
            "limegreen",
            "gold",
            "indianred",
            "darkred",
          ],
          colorsDomain: [0, 40, 100, 160, 230, 255],
          rangeBars: null,
          range: null,
          globalAlpha: 0.6,
          imageSmoothingEnabled: false,
        },
        iso0: {
          name: "Iso 0°C",
          type: "raster",
          zIndex: 110,
          isError: false,
          isReady: false,
          isLoaded: false,
          isSelected: false,
          paramUrl: ["iso0"],
          colors: ["#1A1D27", "white"],
          rangeBars: null,
          range: null,
          globalAlpha: 0,
          imageSmoothingEnabled: false,
        },
        iso268K: {
          name: "Iso -5°C",
          type: "raster",
          zIndex: 110,
          isError: false,
          isReady: false,
          isLoaded: false,
          isSelected: false,
          paramUrl: ["iso268K"],
          colors: ["#1A1D27", "white"],
          rangeBars: null,
          range: null,
          globalAlpha: 0,
          imageSmoothingEnabled: false,
        },
        iso263K: {
          name: "Iso -10°C",
          type: "raster",
          zIndex: 110,
          isError: false,
          isReady: false,
          isLoaded: false,
          isSelected: false,
          paramUrl: ["iso263K"],
          colors: ["#1A1D27", "white"],
          rangeBars: null,
          range: null,
          globalAlpha: 0,
          imageSmoothingEnabled: false,
        },
        lftx: {
          name: "Indice de soulèv.",
          type: "raster",
          zIndex: 110,
          isError: false,
          isReady: false,
          isLoaded: false,
          isSelected: false,
          paramUrl: ["lftx"],
          colors: [
            "blue",
            "turquoise",
            "limegreen",
            "gold",
            "indianred",
            "darkred",
          ],
          colorsDomain: [0, 40, 100, 160, 230, 255],
          rangeBars: null,
          range: null,
          globalAlpha: 0.6,
          imageSmoothingEnabled: false,
        },
      },
    };
  },
  watch: {
    tooltip: {
      deep: true,
      handler: _.debounce(function () {
        this.tooltip.show = false;
      }, 3000),
    },
    maps: _.debounce(function () {
      _.each(this.$children, function (children) {
        children.map.invalidateSize();
      });
    }, 100),
  },
  mounted: function () {
    this.isChrome = navigator.userAgent.indexOf("Chrome") > -1;
  },
};
</script>
<style lang="scss" >

.weathermap-container-map {
    position: relative;
}

.weathermap-container {
  
  /*rangebar*/
  .range_bars {
    position: absolute;
    z-index: 2;
    top: 7em;
    left: 0.25em;
    width: auto;
  }

  .range_bar {
    display: inline-block;
    margin-right: 0.25em;
  }

  .range_bar-param {
    width: 2em;
  }

  .range_bar-head {
    text-align: center;
    font-size: 0.6em;
    color: white;
    line-height: 2em;
    text-shadow: 0 0 1px rgba(0, 0, 0, 0.8);
  }

  .range_bar-color {
    position: relative;
    text-align: center;
  }

  .range_bar-color .value {
    position: absolute;
    z-index: 1;
    display: block;
    top: 50%;
    left: 0;
    width: 100%;
    font-size: 0.8em;
    text-shadow: 0 0 1px rgba(255, 255, 255, 0.8);
    transform: translateY(-50%);
  }

  .range_bar-color .color {
    display: block;
    height: 1em;
  }

  /*tooltip*/
  #tooltip {
    position: absolute;
    z-index: 2;
    padding: 0.6em 1em 0.5em 1em;
    line-height: 1.4em;
    cursor: crosshair;
    text-align: left;
    white-space: nowrap;
    border-radius: 0.3em;
    font-size: 0.8em;
    color: white;
    transform: translateX(-50%) translateY(calc(-100% - 2em));
    background-color: rgba(0, 0, 0, 0.5);
    user-select: none;
    visibility: hidden;
  }
  #tooltip:after {
    content: "";
    display: block;
    position: absolute;
    visibility: hidden;
    top: 100%;
    left: 50%;
    height: 2em;
    width: 2px;
    transform: translateX(-50%);
    background-color: rgba(0, 0, 0, 0.5);
  }
  #tooltip b {
    text-align: right;
    display: inline-block;
    min-width: 2em;
  }
  #tooltip small {
    text-align: left;
    display: inline-block;
    min-width: 2em;
  }
  #tooltip.active,
  #tooltip.active:after {
    visibility: visible;
  }


}
</style>